module.exports = __webpack_public_path__ + "static/1-initial-8aabcdbb24b4233b50de4e2155eafd7c.svg";